import { Plus } from 'lucide-react';
import { useMemo, useState } from 'react';
import { theme } from 'styles/theme/theme';
import UDButton from 'ud-ui/components/button';
import UDSearchInput from 'ud-ui/components/search';
import { Player, Team } from 'modules/players/domain/interfaces/player';
import useModalAddToTeam from '../hooks/use-modal-add-to-team';
import TeamCard from './team-card';

interface IProps {
  player: Player;
  teams: Team[];
}

function TeamsList(props: IProps) {
  const { teams, player } = props;
  const { open: openModalAddToTeam, Modal: ModalAddToTeam } = useModalAddToTeam();

  const [searchValue, setSearchValue] = useState('');
  const handleSearch = (value: string) => setSearchValue(value);

  const filteredTeams = useMemo(() => {
    if (!searchValue) {
      return teams;
    } else {
      return teams.filter((team) => team.name.toLowerCase().includes(searchValue.toLowerCase()));
    }
  }, [searchValue, teams]);

  const body = useMemo(() => {
    if (!teams || teams?.length === 0) {
      return (
        <div className="w-full px-6 pt-6">
          <div className="flex-center mt-24 flex flex-col">
            <div className="text body-text bold mb-2">Игрок не состоит ни в одной команде</div>
          </div>
        </div>
      );
    }

    return (
      <div className={'flex flex-col'} style={{ gap: 16 }}>
        {filteredTeams.map((team, index) => {
          return <TeamCard player={player} key={team.id} team={team} index={index} />;
        })}
      </div>
    );
  }, [filteredTeams, player.id, teams]);

  return (
    <>
      <div className={'flex w-full justify-between'}>
        {teams.length > 0 ? (
          <UDSearchInput
            style={{ marginBottom: 24 }}
            value={searchValue}
            placeholder={'Поиск по команде'}
            onChange={(event) => handleSearch(event.target.value)}
          />
        ) : (
          <div />
        )}
        <UDButton className={'flex-center'} style={{ height: 38 }} variant={'dark'} onClick={() => openModalAddToTeam(player)}>
          <Plus size={16} className="mr-2" color={theme.colors.AccentNaplesYellow} />
          Добавить в команду
        </UDButton>
      </div>

      {body}

      <ModalAddToTeam />
    </>
  );
}

export default TeamsList;
